import React from "react";
import middleware from "./middlewares/middleware";
import ManageAllBanner from "../component/sections/advertise/manage/banner/AllBanner";
import ManageEditBanner from "../component/sections/advertise/manage/banner/EditBanner";
import AllBannerDeleted from "../component/sections/advertise/manage/banner/AllBannerDeleted";
import BannerInfoDeleted from "../component/sections/advertise/manage/banner/BannerInfoDeleted";
import EditBanner from "../component/sections/advertise/manage/banner/EditBanner";

import ManageAllNative from "../component/sections/advertise/manage/native/AllNative";
import ManageEditNative from "../component/sections/advertise/manage/native/EditNative";
import AllNativeDeleted from "../component/sections/advertise/manage/native/AllNativeDeleted";
import NativeInfoDeleted from "../component/sections/advertise/manage/native/NativeInfoDeleted";

import AddBannerAlternative from "../component/sections/advertise/manage/banner/alternative/Add";
import AllBannerAlternative  from "../component/sections/advertise/manage/banner/alternative/All";
import EditBannerAlternative from "../component/sections/advertise/manage/banner/alternative/Edit";

const manageAdvertiseRoutes = [
  {
    path: "/advertise/manage/banner/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageAllBanner />,
        "ManageAllBanner"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/manage/banner/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditBanner />,
        "EditBanner"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/manage/banner/all/deleted",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllBannerDeleted />,
        "AllBannerDeleted"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/manage/banner/all/deleted/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <BannerInfoDeleted />,
        "BannerInfoDeleted"
      );
    },
    exact: true,
  },

  {
    path: "/advertise/manage/native/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageAllNative />,
        "ManageAllNative"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/manage/native/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageEditNative />,
        "ManageEditNative"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/manage/native/all/deleted",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllNativeDeleted />,
        "AllNativeDeleted"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/manage/native/all/deleted/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <NativeInfoDeleted />,
        "NativeInfoDeleted"
      );
    },
    exact: true,
  },
];

export default manageAdvertiseRoutes;
